import React from 'react';
import getConfig from 'next/config';

import { isOwnerClientId } from '../../helpers/clientContext';
import styles from './Header.module.scss';

type HeaderProps = {
  clientId?: string;
};

export const Header = ({ clientId }: HeaderProps) => {
  const { publicRuntimeConfig } = getConfig() as {
    publicRuntimeConfig?: { HAVEN_DOMAIN?: string; OWNERS_DOMAIN?: string };
  };
  const havenDomain = publicRuntimeConfig?.HAVEN_DOMAIN || 'https://www.haven.com';
  const ownersDomain = publicRuntimeConfig?.OWNERS_DOMAIN || 'https://owners.haven.com';
  const logoLink = clientId && isOwnerClientId(clientId) ? ownersDomain : havenDomain;

  return (
    <header className={styles.header}>
      <a href={logoLink}>
        <img
          src="https://www.haven.com/assets/logos/haven_logo_colour.svg"
          alt="Haven"
          width="115px"
          height="43px"
        />
      </a>
    </header>
  );
};
